// libs
import styled from "styled-components";
// theme
import { colors, typography } from "src/theme";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  background-color: ${colors.white};
  padding: 19px;
  box-shadow: 0 8px 64px -32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: max-content;
  max-width: 320px;
`;

export const CloseIconWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;

  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border: 2px solid ${colors.greyVeryLight};
  border-radius: 50%;
  cursor: pointer;

  :hover {
    background-color: ${colors.mainVeryLight};
  }
`;

export const Row = styled.div<{ margin?: string }>`
  display: flex;
  align-items: center;
  ${({ margin }) => margin && `margin: ${margin}`};
`;

export const InnerWrapper = styled.div`
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s all ease;
  padding: 5px;
`;

export const NextImageWrapper = styled.div<{ bg: string }>`
  width: 100%;
  min-width: 100%;
  height: 185px;

  border-radius: 8px;
  background-image: ${({ bg }) => `url(${bg})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: inherit;
  background-position-x: center;
`;

export const ClinicTitle = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.greyDark};
  margin-top: 16px;
`;

export const ClinicAddress = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
  margin-right: 10px;
  max-width: 83%;
`;

export const RatingCountText = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${colors.main};
  margin-left: 10px;
`;

export const RateText = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
`;

export const SpeciesList = styled.ul`
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: wrap;
`;

export const SpeciesItem = styled.li<{ offsetFirst?: boolean }>`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
  list-style-position: inside;
  padding-left: 15px;
`;

export const Star = styled.div`
  width: 25px;
  height: 20px;
  background-image: url("/icons/star-full-blue.svg");
  background-repeat: no-repeat;
`;
